import React, { useContext, useState } from 'react';
import { Button, Label,  Table,Confirm, Container, Menu, Tab } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import AssetStore from '../../../app/stores/assetStore';
import { Link } from 'react-router-dom';
import { RootStoreContext } from '../../../app/stores/rootStore';
import BarcodeView from './BarcodeView';

const Asset: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [requestId, setRequestId] = useState("");
  const rootStore = useContext(RootStoreContext);
  const {openModal} = rootStore.modalStore;
  const assetStore = useContext(AssetStore);
  const {assetsByCode,  deleteAsset: deleteAsset, setActiveListTab, activeListTab, submitting, target} = assetStore;

  const types = [
    "Equipment",
    "Tool",
    "Vehicle",
  ];

  let countOfEquipment = 0;
  let countOfTool = 0;
  let countOfVehicle = 0;

  assetsByCode.map(asset => {
    if (asset.type === 'Equipment') countOfEquipment ++; 
    if (asset.type === 'Tool') countOfTool ++; 
    if (asset.type === 'Vehicle') countOfVehicle ++; 
  });

  const panes = types.map((type) => {
    return {
    menuItem: ( (type === 'Equipment') ? <Menu.Item><strong style={{color: 'purple'}}>Equipment</strong><Label>{countOfEquipment}</Label></Menu.Item> : 
                (type === 'Tool') ? <Menu.Item><strong style={{color: 'purple'}}>Tool</strong><Label>{countOfTool}</Label></Menu.Item> : 
                (type === 'Vehicle') ? <Menu.Item><strong style={{color: 'purple'}}>Vehicle</strong><Label>{countOfVehicle}</Label></Menu.Item> : 
      ''),
      render: () => (
        <Table celled>
          <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Code</Table.HeaderCell>
        <Table.HeaderCell>Name</Table.HeaderCell>
        <Table.HeaderCell>Model</Table.HeaderCell>
        <Table.HeaderCell>Status</Table.HeaderCell>
        <Table.HeaderCell>Keeper</Table.HeaderCell>
       <Table.HeaderCell>{(type === 'Tool') ? 'Inspection Date' : 'Keep Date'}</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

          <Table.Body>
            {assetsByCode.map(
              (asset) => 
              asset.type === type && (
                  <Table.Row key={asset.id}>
          <Table.Cell width='1'>
          {asset.code}
        </Table.Cell>
        <Table.Cell>{asset.assetName}</Table.Cell>
        <Table.Cell>{asset.model}</Table.Cell>
        <Table.Cell>{asset.status}</Table.Cell>
        <Table.Cell>{asset.keep[0].keeper}</Table.Cell>
        { (asset.type === 'Tool') ? 
        (asset.inspectionDate < new Date().toISOString()) ? 
    <Table.Cell width='2' style={{backgroundColor: 'red'}}>{asset.inspectionDate.substr(8,2) + '/' +
    asset.inspectionDate.substr(5,2) + '/' + asset.inspectionDate.substr(0,4)}</Table.Cell>
     : (asset.inspectionDate < new Date(new Date().setMonth(new Date().getMonth()+1)).toISOString()) ? 
     <Table.Cell width='2' style={{backgroundColor: 'yellow'}}>{asset.inspectionDate.substr(8,2) + '/' +
     asset.inspectionDate.substr(5,2) + '/' + asset.inspectionDate.substr(0,4)}</Table.Cell> 
     : <Table.Cell width='2'>{(asset.inspectionDate) && asset.inspectionDate.substr(8,2) + '/' +
     asset.inspectionDate.substr(5,2) + '/' + asset.inspectionDate.substr(0,4)}</Table.Cell> : 
     <Table.Cell width='2'>
      {asset.keep[0].keepDate.substr(8,2) + '/' + asset.keep[0].keepDate.substr(5,2) + '/' + asset.keep[0].keepDate.substr(0,4)}
     </Table.Cell>} 
        <Table.Cell width='1'>
        <Button.Group size='mini'>
                <Button
                  as={Link}
                  to={`/dailymanagement/asset/${asset.id}`}
                  size='mini'
                  title='View'
                  color='blue'
                  icon='zoom in'
                />
                <Button
                  name={asset.id}
                  size='mini'
                  loading={target === asset.id && submitting}
                  //onClick={(e) => deleteAsset(e, asset.id)}
                  onClick={() => {
                    setOpen(true);
                    setRequestId(asset.id);
                  }}
                  icon="delete"
                  color="red"
                  title="Delete"
                />
                <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteAsset(requestId);
                        setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                  <Button
                  onClick={() => openModal(<BarcodeView url={asset.barcodeUrl} />)}
                  size='mini'
                  icon="picture"
                  color="green"
                  title="Barcode"
                />
          </Button.Group>
        </Table.Cell>
        </Table.Row>
                )
            )}
          </Table.Body>
        </Table>
      ),
    };
  });
  
  return (
    <Container fluid>
      <Tab 
      panes={panes} 
      menu={{ pointing: true }} 
      onTabChange={(e, data) => setActiveListTab(Number(data.activeIndex))}
      defaultActiveIndex={activeListTab}
      />
    </Container>
  );
};

export default observer(Asset);
